var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 12.0002C17.3333 12.7366 16.7363 13.3336 15.9999 13.3336C15.2635 13.3336 14.6666 12.7366 14.6666 12.0002C14.6666 11.2638 15.2635 10.6669 15.9999 10.6669C16.7363 10.6669 17.3333 11.2638 17.3333 12.0002Z",
    fill: "#E74C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 15.6669C16.5522 15.6669 16.9999 16.1146 16.9999 16.6669V23.3336C16.9999 23.8858 16.5522 24.3336 15.9999 24.3336C15.4476 24.3336 14.9999 23.8858 14.9999 23.3336V16.6669C14.9999 16.1146 15.4476 15.6669 15.9999 15.6669Z",
    fill: "#E74C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.027 5.32374C17.5711 3.19352 14.4287 3.19351 12.9727 5.32374L12.3968 6.16633C8.78878 11.4453 5.68883 17.0541 3.13853 22.9177L3.01824 23.1942C2.1195 25.2606 3.47732 27.6069 5.71671 27.8572C12.5509 28.621 19.4489 28.621 26.2831 27.8572C28.5225 27.6069 29.8803 25.2606 28.9815 23.1942L28.8613 22.9177C26.3109 17.0541 23.211 11.4453 19.6029 6.16634L19.027 5.32374ZM14.6239 6.45228C15.2857 5.484 16.7141 5.484 17.3759 6.45229L17.9518 7.29488C21.4886 12.4696 24.5273 17.9676 27.0272 23.7154L27.1475 23.9919C27.5094 24.824 26.9626 25.7688 26.0609 25.8695C19.3744 26.6169 12.6254 26.6169 5.93886 25.8695C5.03713 25.7688 4.49038 24.824 4.85228 23.9919L4.97256 23.7154C7.4725 17.9676 10.5112 12.4696 14.048 7.29488L14.6239 6.45228Z",
    fill: "#E74C4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.b670c14f01e5523b1c45bf98e5d42a7d.svg";
export { ForwardRef as ReactComponent };